export const trackEvent = (name: string, props?: Record<string, unknown>) => {
  if (!window.fathom) {
    return;
  }

  window.fathom.trackEvent(name, props);
};
